import setGrabCursor from './setGrabCursor';
import unsetGrabCursor from './unsetGrabCursor';
export default {
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
};


//////////////////
// WEBPACK FOOTER
// /Users/jared/Documents/Work/elevato/elevato-website/src/httpdocs/wp-content/themes/elevato/node_modules/swiper/esm/components/core/grab-cursor/index.js
// module id = 75
// module chunks = 0